import React from 'react';
import ForgottenPasswordForm from '../Forms/ForgottenPasswordForm';

export default class ForgottenPasswordPage extends React.Component {
    render = () => (
        <div className="login-background d-flex no-block justify-content-center align-items-center">
            <ForgottenPasswordForm className="bg-white p-4" />
        </div>
    );
}
